import { render } from "./CComplaints.vue?vue&type=template&id=b280a08c&scoped=true"
import script from "./CComplaints.vue?vue&type=script&lang=js"
export * from "./CComplaints.vue?vue&type=script&lang=js"

import "./CComplaints.vue?vue&type=style&index=0&id=b280a08c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b280a08c"]])

export default __exports__